import React from 'react'

const PetOfferMethod = () => {
  return <div>offer method</div>
}

export default PetOfferMethod
